module.exports = __webpack_public_path__ + "img/header-t.84c06c05.jpg";